import { render } from "./collapseBox.vue?vue&type=template&id=6a4db9e8&scoped=true"
import script from "./collapseBox.vue?vue&type=script&lang=js"
export * from "./collapseBox.vue?vue&type=script&lang=js"

import "./collapseBox.vue?vue&type=style&index=0&id=6a4db9e8&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4db9e8"]])

export default __exports__